<template>
  <transition name="fade" appear>
    <!--    lead not exist -->
    <div class="full-size flex-block-center" v-if="!doc">
      <div class="text-center" style="opacity:.4">
        <div class="pa-5"><v-icon size="50">mdi-link-variant-off</v-icon></div>
        Lead doesn't exist!
      </div>
    </div>
    <div v-if="doc">
      <hi-row class="name" flex>
        <div class="flex-grow-1">
          <div style="display:flex;align-items: center;">
            <div style="height:100%" class="pr-3" v-if="doc.photoURL">
              <v-avatar :size="45">
                <img :src="doc.photoURL" alt="" />
              </v-avatar>
            </div>
            <h3 class="capitalize py-5">{{ doc | fullName }}</h3>
          </div>

          <div>
            <span class="pb-2 ui-text">
              Project <span class="ui-text-darker">{{ projects }}</span> |
              <di-src :doc="doc"
                >SRC
                <span class="ui-text-darker">{{
                  doc.source || "N/A"
                }}</span></di-src
              >
            </span>
          </div>
        </div>
        <div class="pt-2 text-right" style="width:100px">
          <v-menu bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="deleteLead()">
                <v-list-item-title>Delete</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </hi-row>

      <v-divider></v-divider>
      <hi-row class="sec-tools " flex baseline separator :py="5">
        <HiDatePicker
          class="ui-text-clickable"
          @pick="pickFollowUp"
          v-if="checkEmpty('followUp')"
          future
          >Follow-Up</HiDatePicker
        >
        <v-spacer></v-spacer>
        <HiIcon
          v-if="checkEmpty('email')"
          tip="Emails"
          @click="openDialog('diEmail')"
          >mdi-email</HiIcon
        >
        <HiIcon
          v-if="checkEmpty('phone') && checkEmpty('mobile')"
          tip="Phone Numbers"
          @click="openDialog('diPhone', doc)"
          >mdi-phone</HiIcon
        >
        <HiIcon
          v-if="checkEmpty('budget')"
          tip="Budget"
          @click="openDialog('dialogBudget')"
          >mdi-currency-usd</HiIcon
        >
        <HiIcon
          v-if="checkEmpty('labels')"
          tip="Labels"
          @click="openDialog('dialogLabels')"
          >mdi-label-multiple</HiIcon
        >
      </hi-row>
      <!-- <div v-for="(email,index) in data.emails" :key="index">{{email.email}} <span v-if="email.label" class="contact-label">{{email.label}}</span></div>
    <div v-for="(phone,index) in data.phones" :key="index">{{phone.number}} <span v-if="phone.label" class="contact-label">{{phone.label}}</span></div>-->

      <hi-row separator py-sm v-if="!checkEmpty('followUp')">
        <FollowUpDisplay :doc="doc"></FollowUpDisplay>
      </hi-row>

      <hi-row v-if="!checkEmpty('labels')" py-sm separator>
        <HiEditTrigger class="flex-row-base" @edit="openDialog('dialogLabels')">
          <v-icon small class="pr-2">mdi-label-multiple</v-icon>
          <div>
            <span
              v-for="val in doc.labels"
              :key="val"
              class="label"
              :style="{
                color: getLabelColor(val)[0],
                backgroundColor: getLabelColor(val)[1]
              }"
              >{{ val }}</span
            >
          </div>
        </HiEditTrigger>
      </hi-row>
      <hi-row v-if="!checkEmpty('email')" py-sm separator flex>
        <v-icon small class="pr-2">mdi-email</v-icon>
        <HiEditTrigger
          class="flex-row-base"
          @edit="openDialog('diEmail', doc.email)"
        >
          {{ doc.email }}
        </HiEditTrigger>
      </hi-row>

      <hi-row
        flex
        py-sm
        separator
        v-if="!checkEmpty('phone') || !checkEmpty('mobile')"
      >
        <div style="height:100%">
          <v-icon small class="pr-2">mdi-phone</v-icon>
        </div>
        <HiEditTrigger @edit="openDialog('diPhone', doc)">
          <div v-if="doc.phone">
            {{ doc.phone }}
          </div>
          <div v-if="doc.mobile">
            {{ doc.mobile | mobile }}
            <span class="ui-text-italic">(mobile)</span>
          </div>
        </HiEditTrigger>
      </hi-row>
      <hi-row flex py-sm separator v-if="!checkEmpty('budget')">
        <HiEditTrigger class="flex-row-base" @edit="openDialog('dialogBudget')">
          <div style="height:100%">
            <v-icon small class="pr-2">mdi-currency-usd</v-icon>
          </div>
          <div>
            <span style="font-weight:bold">{{ doc.budget[0] }}</span>
            <span style="font-size:.6em;opacity:.6">Million</span>
            <span style="font-weight:bold">{{ doc.budget[1] }}</span>
            <span style="font-size:.6em;opacity:.6" v-if="doc.budget.length > 1"
              >Million</span
            >
          </div>
        </HiEditTrigger>
      </hi-row>
      <hi-row flex py-sm separator v-if="!checkEmpty('postcode')">
        <div style="height:100%">
          <v-icon small class="pr-2">mdi-postage-stamp</v-icon>
        </div>
        <div>
          <Postcode v-model="doc.postcode"></Postcode>
        </div>
      </hi-row>
      <hi-row flex py-sm separator>
        <div style="height:100%">
          <v-icon small class="pr-2">mdi-account-plus</v-icon>
        </div>

        <div>
          <!--          <div v-html="regInfo" v-if="regInfo"></div>-->
          <div v-if="doc.type === 'IMP'">
            Imported by {{ users[doc.importedBy] }} on
            {{ doc.dateImported | timestamp(true) }}
            <div v-if="doc.dateCreated">
              Created on {{ doc.dateCreated | timestamp(true) }}
            </div>
          </div>
          <div v-if="doc.type === 'MAN'">
            Created by {{ users[doc.createdBy] }} on
            {{ doc.dateCreated | timestamp(true) }}
          </div>
          <div v-if="doc.type === 'EML'">
            Emailed by {{ doc.source }} on
            {{ doc.dateCreated | timestamp(true) }}
          </div>
          <div v-if="doc.type === 'WHK'">
            Received thru webhook by {{ doc.source }} on
            {{ doc.dateCreated | timestamp(true) }}
            <div class="ui-text-italic">
              FBook Page Id: {{ doc.facebook.pageId }}
            </div>
            <div class="ui-text-italic">
              FBook Ad Id: {{ doc.facebook.adId }}
            </div>
          </div>
          <div v-if="doc.type === 'REG'">
            Registered on
            {{ doc.dateCreated | timestamp(true) }}
          </div>
          <div v-if="doc.regHost">
            <span class="ui-text-italic">From </span>
            <a
              :href="doc.regURL ? doc.regURL : 'https://' + doc.regHost"
              class="ui-text-italic"
              >{{ doc.regHost }}
            </a>
          </div>

          <div v-if="doc.regIP">
            <div class="ui-text-italic bold">IP address</div>
            <IP v-model="doc.regIP"></IP>
          </div>
          <div v-if="doc.reaPropertyID">
            <div class="ui-text-italic">
              REA Property ID:
              <a :href="reaProperty" target="_blank">{{ doc.reaPropertyID }}</a>
            </div>
          </div>
          <div v-if="doc.domainId">
            <div class="ui-text-italic">
              Domain ID:
              <a :href="domainProject" target="_blank">{{ doc.domainId }}</a>
            </div>
          </div>
          <div v-if="doc.requested">
            <div class="ui-text-italic">
              User has requested:
            </div>
            <div class="ui-text" v-html="doc.requested"></div>
          </div>
          <div v-if="doc.aboutMe">
            <div class="ui-text-italic bold">About Me</div>
            <div>{{ doc.aboutMe }}</div>
          </div>
          <div v-if="doc.regReferrerDomain" class="ui-text">
            <div class="ui-text-italic bold">
              REF: {{ doc.regReferrerDomain }}
            </div>
            <div class="word-break-all">{{ doc.regReferrer }}</div>
          </div>
          <div v-if="platform" class="ui-text">
            <div class="ui-text-italic bold">Device</div>
            {{ platform }}
          </div>
          <div v-if="doc.regMessage">
            <div class="ui-text-italic bold">Message</div>
            <div
              v-html="doc.regMessage.replace(/(?:\r\n|\r|\n)/g, '<br/>')"
            ></div>
          </div>
        </div>
      </hi-row>

      <!--                            Dialogs                                  -->
      <DLBudget :id="doc.id" ref="dialogBudget"></DLBudget>
      <DLLeadLabels :id="doc.id" ref="dialogLabels"></DLLeadLabels>
      <di-email-editor
        ref="diEmail"
        collection-path="leads"
        :doc-path="id"
      ></di-email-editor>
      <di-phone-editor
        collection-path="leads"
        :doc-path="id"
        ref="diPhone"
      ></di-phone-editor>
    </div>
  </transition>
</template>

<script>
// import axios from "axios";
// import Vue from "vue";
import {
  collections,
  docHelpers,
  docs,
  // db,
  // serverTimestamp,
  users
} from "@/db";
// import ContactDisplay from "../ContactDisplay";
import HiIcon from "../HiIcon";
import Postcode from "../segments/Postcode";
import HiEditTrigger from "../HiEditTrigger";
import DLBudget from "./DLBudget";
import DLLeadLabels from "./DLLeadLabels";
import HiDatePicker from "@/components/HiDatePicker";
import FollowUpDisplay from "@/components/leads/FollowUpDisplay";
import IP from "@/components/segments/IP";
import platform from "platform";
// import hive from "@/hive";
import { leads } from "@/db";
import HiRow from "@/components/scaffold/HiRow";
import DiEmailEditor from "@/components/DiEmailAdressEditor";
import hive from "@/hive";
import DiPhoneEditor from "@/components/DiPhoneEditor";
import moment from "moment";
import { api } from "@/api";
import DiSrc from "@/components/leads/DiSrc";

// import DLEditor from "@/components/DLEditor";

export default {
  components: {
    DiSrc,
    DiEmailEditor,
    HiRow,
    IP,
    // DLEditor,
    FollowUpDisplay,
    HiDatePicker,
    // ContactDisplay,
    HiIcon,
    DLBudget,
    Postcode,
    HiEditTrigger,
    DLLeadLabels,
    DiPhoneEditor
  },
  mounted() {
    // console.log("this.$r", this.$router);
    this.id = this.$route.params.id;
    console.log("lead details mounted");
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      doc: null,
      labelsDoc: {},
      users: {}
    };
  },
  methods: {
    checkEmpty(key) {
      if (!this.doc) return true;
      if (!this.doc[key]) return true;
      return !this.doc[key].length;
    },
    openDialog(ref, initVal) {
      this.$refs[ref].open(initVal);
    },
    getLabelColor(key) {
      const colors = this.labelsDoc[key];
      return colors || [];
    },
    pickFollowUp(date) {
      leads.followUp(this.id, date);
    },
    async deleteLead() {
      let yes = await hive.confirm(
        "Are you sure you want to delete lead '" + this.doc.name + "'?"
      );
      if (yes) await docHelpers.lead(this.id).delete();
    },
    async getUser(id) {
      await users.getFullName(id);
    },
    async update() {
      if (!this.doc) return;
      // console.log(this.doc);
      const doc = this.doc;
      // const type = doc.type;
      // const user = doc.createdBy;
      // let pre = "";
      // if (type === "MAN") {
      //   //TODO check get users is cached
      //   pre = "Created by " + (await users.getFullName(user)) + " on ";
      // } else if (type === "IMP") {
      //   pre = "Imported by " + (await users.getFullName(user)) + " on ";
      // } else if (type === "REG") {
      //   pre = "Registered on ";
      // } else if (type === "EML") {
      //   pre = "Emailed by " + doc.source + " on ";
      // }
      // this.creationInfo = pre;

      // update users
      const updateUser = async id => {
        if (!id) return;
        // console.log("updateUser: " + id);
        this.$set(this.users, id, await users.getFullName(id));
      };
      // console.log("update....");
      await updateUser(doc.createdBy);
      await updateUser(doc.importedBy);
    }
  },
  firestore() {
    return {
      labelsDoc: docs.labels.leads
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.params.id) {
          this.$bind("doc", collections.leads.doc(route.params.id));
          // const result = api.leads.visit(this.doc.id);
          // console.log(result);
          // .then(
          // document => {
          //   // console.log("binding complete");
          //   // console.log(document);
          //   const obj = {};
          //   obj["userVisits." + users.currentUserUid()] = serverTimestamp();
          //   // console.log(obj);
          //   db.collection("leads")
          //     .doc(document.id)
          //     .update(obj);
          //   }
          // );
        }
      }
    },
    doc: {
      // immediate: true,
      async handler() {
        if (!this.doc) return;
        await this.update();
        // console.log(JSON.stringify(this.doc));
        const dateUpdated = this.doc.dateUpdated;
        const momentUpdated = moment.unix(dateUpdated.seconds);
        // console.log(momentUpdated);

        const userVisits = this.doc.userVisits;
        let updateVisit = false;
        if (!userVisits) updateVisit = true;
        else {
          const visitTime = userVisits[users.currentUserUid()];
          if (!visitTime) updateVisit = true;
          else {
            const momentVisited = moment.unix(visitTime.seconds);
            if (momentUpdated.isAfter(momentVisited)) {
              // console.log(momentVisited);
              updateVisit = true;
            }
          }
        }
        // console.log(updateVisit);
        if (updateVisit) {
          const result = await api.leads.visit(this.doc.id);
          console.log(result);
          // const obj = {};
          // obj["userVisits." + users.currentUserUid()] = serverTimestamp();
          // console.log(obj);
          // db.collection("leads")
          //   .doc(this.doc.id)
          //   .update(obj);
        }
      }
    }
  },
  computed: {
    reaProperty() {
      return "http://www.realestate.com.au/" + this.doc.reaPropertyID;
    },
    domainProject() {
      return "https://www.domain.com.au/project/" + this.doc.domainId;
    },
    platform() {
      if (!this.doc.regUA) {
        return null;
      }
      const info = platform.parse(this.doc.regUA);
      return info.description;
    },
    projects() {
      if (this.doc.projects) {
        return this.doc.projects.join(" & ");
      }
      return "N/A";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/global.scss";
.display-box {
  @extend .flex-row-base;
  width: 100%;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 20px;
  padding-right: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.name {
  background-color: $light5;
}
</style>
